import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/plugins/app/layout/Home'
// import HomeApp from '@/plugins/app/layout/HomeApp'
import Kyforum from '@/plugins/app/project/Kyforum'
// import KyforumApp from '@/plugins/app/project/KyforumApp'
import DXZXteam from '@/plugins/app/project/DXZXteam'
import YKteam from '@/plugins/app/project/YKteam'
import ZxfwList from '@/plugins/app/project/ZxfwList'
import ZxfwPL from '@/plugins/app/project/ZxfwPL'
import FlfwList from '@/plugins/app/project/FlfwList'
import FlfwPL from '@/plugins/app/project/FlfwPL'
import KyltCom from '@/plugins/app/project/KyltCom'
import Kyzx from '@/plugins/app/project/Kyzx'
import KyzxIndex from '@/plugins/app/project/KyzxIndex'
import KyzxList from '@/plugins/app/project/KyzxList'
import KyzxDetails from '@/plugins/app/project/KyzxDetails'
import HzxmKYXMList from '@/plugins/app/project/HzxmKYXMList'
import HyzjList from '@/plugins/app/project/HyzjList'
import KyqtjList from '@/plugins/app/project/KyqtjList'
import HzxmKYXMDetails from '@/plugins/app/project/HzxmKYXMDetails'
import HyzjDetails from '@/plugins/app/project/HyzjDetails'
import HzxmKCPList from '@/plugins/app/project/HzxmKCPList'
import HzxmKCPDetails from '@/plugins/app/project/HzxmKCPDetails'
import HzxmZBYSList from '@/plugins/app/project/HzxmZBYSList'
import HzxmZBYSDetails from '@/plugins/app/project/HzxmZBYSDetails'
import HzxmKYSBList from '@/plugins/app/project/HzxmKYSBList'
import HzxmKYSBDetails from '@/plugins/app/project/HzxmKYSBDetails'
import HzxmKYJSList from '@/plugins/app/project/HzxmKYJSList'
import HzxmKYJSDetails from '@/plugins/app/project/HzxmKYJSDetails'
import KyqtjDetails from '@/plugins/app/project/KyqtjDetails'
import KYhome from '@/plugins/app/layout/KYhome'
// import KYhomeApp from '@/plugins/app/layout/KYhomeApp'
import Zlk from '@/plugins/app/project/Zlk'
import ZlkTabsList from '@/plugins/app/project/ZlkTabsList'
import ZlkTabsList1 from '@/plugins/app/project/ZlkTabsList1'
import ZlkListDouble from '@/plugins/app/project/ZlkListDouble'
import ZlkCom from '@/plugins/app/project/ZlkCom'
import ZlkList from '@/plugins/app/project/ZlkList'
import ZlkDetails from '@/plugins/app/project/ZlkDetails'
import ZlkKeywords from '@/plugins/app/project/ZlkKeywords'
import Promoin from '@/plugins/app/project/Promoin'
// import PromoinApp from '@/plugins/app/project/PromoinApp'
import Ltgk from '@/plugins/app/project/Ltgk'
import Ltzlhgk from '@/plugins/app/project/Ltzlhgk'
import NewsList from '@/plugins/app/project/NewsList'
import NewsKyzhzx from '@/plugins/app/project/NewsKyzhzx'
// import NewsListApp from '@/plugins/app/project/NewsListApp'
import DhxwDetails from '@/plugins/app/project/DhxwDetails'
import KyzhzxDetails from '@/plugins/app/project/KyzhzxDetails'
import LtgkDetails from '@/plugins/app/project/LtgkDetails'
import Oldnews from '@/plugins/app/project/Oldnews'
import MeetingEnroll from '@/plugins/app/project/MeetingEnroll'
import Exhibition from '@/plugins/app/project/Exhibition'
import MemberHome from '@/plugins/app/project/MemberHome'
import Bhxxb from '@/plugins/app/project/Bhxxb'
import Chxxb from '@/plugins/app/project/Chxxb'
import QyzsList from '@/plugins/app/project/QyzsList'
import SjgxDetails from '@/plugins/app/project/SjgxDetails'
import CompanyShow from '@/plugins/app/project/CompanyShow'
import Dmky from '@/plugins/app/project/Dmky'
import DmkyDetails from '@/plugins/app/project/DmkyDetails'
import ZhikuDetails from '@/plugins/app/project/ZhikuDetails'
import Gywm from '@/plugins/app/project/Gywm'
import ZjDetails from '@/plugins/app/project/ZjDetails'
import ProductView from '@/plugins/app/project/ProductView'
import QXdetails from '@/plugins/app/project/QXdetails'
import Thinktank from '@/plugins/app/project/Thinktank'
import Dmgeonomy from '@/plugins/app/project/Dmgeonomy'
import DMgeoList from '@/plugins/app/project/DMgeoList'
import PDFfile from '@/plugins/app/assembly/PDFfile'
import FictitiousZT from '@/plugins/app/project/FictitiousZT'
import PanoramicView from '@/plugins/app/project/PanoramicView'
import Hyxqwq from '@/plugins/app/project/Hyxqwq'
import Hyxqzk from '@/plugins/app/project/Hyxqzk'
import Kyyztoply from '@/plugins/app/assembly/kyyzt/Kyyztoply'
import KyyztModule from '@/plugins/app/assembly/kyxxyzt/KyyztModule'
import HyxqDetails from '@/plugins/app/project/HyxqDetails'
import LargeScreen from '@/plugins/app/assembly/DigitalScreen/LargeScreen'
import MenuRight from '@/plugins/backer/layout/MenuRight'
import ChildrenData from '../router/children'
import loginHT from '@/plugins/backer/login/loginHT'
import Members from '@/plugins/app/project/Members'
import LoginIndex from '@/plugins/app/login/LoginIndex'
import DMinvestment from '@/plugins/app/project/DMinvestment'
import DMinvestmentList from '@/plugins/app/project/DMinvestmentList'
import Forgotpassword from '@/plugins/app/project/Forgotpassword'
import Wzsm from '@/plugins/app/project/Wzsm'
import TradingFloor from '@/plugins/app/project/TradingFloor'
import Rcep from '@/plugins/app/project/Rcep'
import RcepLB from '@/plugins/app/project/RcepLB'
import RcepDetails from '@/plugins/app/project/RcepDetails'
// import Registration from '@/plugins/app/login/Registration'
import SYphotoList from '@/plugins/app/project/SYphotoList.vue'
import SYphotoDetails from '@/plugins/app/project/SYphotoDetails.vue'
import CjwtList from '@/plugins/app/project/CjwtList'

Vue.use(Router)
let obj = {}
let pcobj = {
  mode: 'history',
  base: window.location.hostname === '192.168.2.201' ? '/gisdm/' : '/',
  routes: [
    {
      path: '/',
      component: Home,
      name: 'Home',
      redirect: '/Kyforum',
      children: [
        { path: '/Kyforum', component: Kyforum, name: 'Kyforum', meta: {title: '中国—东盟矿业信息服务平台'} },
        { path: '/Wzsm', component: Wzsm, name: 'Wzsm' },
        { path: '/YKteam', component: YKteam, name: 'YKteam' },
        { path: '/DXZXteam', component: DXZXteam, name: 'DXZXteam' },
        { path: '/ZxfwList', component: ZxfwList, name: 'ZxfwList' },
        { path: '/ZxfwPL', component: ZxfwPL, name: 'ZxfwPL' },
        { path: '/FlfwList', component: FlfwList, name: 'FlfwList' },
        { path: '/FlfwPL', component: FlfwPL, name: 'FlfwPL' },
        { path: '/DMinvestment', component: DMinvestment, name: 'DMinvestment' },
        { path: '/DMinvestmentList', component: DMinvestmentList, name: 'DMinvestmentList' },
        { path: '/CjwtList', component: CjwtList, name: 'CjwtList' }, // 常见问题
        {
          path: '/Kyzx',
          component: Kyzx,
          name: 'Kyzx',
          redirect: '/KyzxIndex',
          children: [
            { path: '/KyzxIndex', component: KyzxIndex, name: 'KyzxIndex' }, //矿业咨询
            { path: '/KyzxList', component: KyzxList, name: 'KyzxList' },
            { path: '/HyzjList', component: HyzjList, name: 'HyzjList' },

            { path: '/KyzxDetails', component: KyzxDetails, name: 'KyzxDetails' }
          ]
        },
        { path: '/TradingFloor', component: TradingFloor, name: 'TradingFloor' },
        { path: '/HzxmKYXMList', component: HzxmKYXMList, name: 'HzxmKYXMList' },
        { path: '/KyqtjList', component: KyqtjList, name: 'KyqtjList' },
        { path: '/HzxmKYXMDetails', component: HzxmKYXMDetails, name: 'HzxmKYXMDetails' },
        { path: '/HyzjDetails', component: HyzjDetails, name: 'HyzjDetails' },
        { path: '/HzxmKCPList', component: HzxmKCPList, name: 'HzxmKCPList' },
        { path: '/HzxmKCPDetails', component: HzxmKCPDetails, name: 'HzxmKCPDetails' },
        { path: '/HzxmZBYSList', component: HzxmZBYSList, name: 'HzxmZBYSList' },
        { path: '/HzxmZBYSDetails', component: HzxmZBYSDetails, name: 'HzxmZBYSDetails' },
        { path: '/HzxmKYSBList', component: HzxmKYSBList, name: 'HzxmKYSBList' },
        { path: '/HzxmKYSBDetails', component: HzxmKYSBDetails, name: 'HzxmKYSBDetails' },
        { path: '/HzxmKYJSList', component: HzxmKYJSList, name: 'HzxmKYJSList' },
        { path: '/HzxmKYJSDetails', component: HzxmKYJSDetails, name: 'HzxmKYJSDetails' },
        { path: '/KyqtjDetails', component: KyqtjDetails, name: 'KyqtjDetails' },
        {
          path: '/Zlk',
          component: Zlk,
          name: 'Zlk',
          children: [
            { path: '/ZlkTabsList', component: ZlkTabsList, name: 'ZlkTabsList' }, //地学资料
            { path: '/ZlkTabsList1', component: ZlkTabsList1, name: 'ZlkTabsList1' },
            { path: '/ZlkListDouble', component: ZlkListDouble, name: 'ZlkListDouble' }
          ]
        },
        {
          path: '/ZlkCom',
          component: ZlkCom,
          name: 'ZlkCom',
          children: [
            { path: '/ZlkList', component: ZlkList, name: 'ZlkList' },
            { path: '/ZlkDetails', component: ZlkDetails, name: 'ZlkDetails' },
            { path: '/ZlkKeywords', component: ZlkKeywords, name: 'ZlkKeywords' }
          ]
        },
        { path: '/Exhibition', component: Exhibition, name: 'Exhibition' }, //线上云展
        { path: '/MemberHome', component: MemberHome, name: 'MemberHome' }, //会员之家
        { path: '/Bhxxb', component: Bhxxb, name: 'Bhxxb' },
        { path: '/Chxxb', component: Chxxb, name: 'Chxxb' },
        { path: '/QyzsList', component: QyzsList, name: 'QyzsList' },
        { path: '/SjgxDetails', component: SjgxDetails, name: 'SjgxDetails' },
        { path: '/CompanyShow', component: CompanyShow, name: 'CompanyShow' },
        { path: '/Dmky', component: Dmky, name: 'Dmky' },
        { path: '/DmkyDetails', component: DmkyDetails, name: 'DmkyDetails' },
        { path: '/ZhikuDetails', component: ZhikuDetails, name: 'ZhikuDetails' },
        { path: '/Gywm', component: Gywm, name: 'Gywm' },
        { path: '/ZjDetails', component: ZjDetails, name: 'ZjDetails' },
        { path: '/Thinktank', component: Thinktank, name: 'Thinktank' },
        { path: '/Dmgeonomy', component: Dmgeonomy, name: 'Dmgeonomy' }, //东盟地学
        { path: '/DMgeoList', component: DMgeoList, name: 'DMgeoList' }, //东盟地学列表页
        { path: '/Hyxqwq', component: Hyxqwq, name: 'Hyxqwq' }, //会议详情（往期）
        { path: '/Hyxqzk', component: Hyxqzk, name: 'Hyxqzk' }, //会议详情（召开中）
        { path: '/HyxqDetails', component: HyxqDetails, name: 'HyxqDetails' }, //大会资讯详情页面
        { path: '/Members', component: Members, name: 'Members' }, //会员中心页面
        { path: '/LoginIndex', component: LoginIndex, name: 'LoginIndex' },
        { path: '/Forgotpassword', component: Forgotpassword, name: 'Forgotpassword' }, //忘记密码页面
        { path: '/Rcep', component: Rcep, name: 'Rcep' },  //Rcep专栏
        { path: '/RcepLB', component: RcepLB, name: 'RcepLB' },  //Rcep专栏列表页
        { path: '/RcepDetails', component: RcepDetails, name: 'RcepDetails' },  //Rcep专栏详情页
        { path: '/SYphotoList', component: SYphotoList, name: 'SYphotoList' },
        { path: '/SYphotoDetails', component: SYphotoDetails, name: 'SYphotoDetails' }
      ]
    },
    {
      path: '/KYhome',
      component: KYhome,
      name: 'KYhome',
      meta: {title: '中国—东盟矿业信息服务平台'},
      children: [
        { path: '/Promoin', component: Promoin, name: 'Promoin' },
        { path: '/wjhg', component: Oldnews, name: 'wjhg' },
        { path: '/chbm', component: MeetingEnroll, name: 'chbm' },
        { path: '/ProductView', component: ProductView, name: 'ProductView' },
        { path: '/QXdetails', component: QXdetails, name: 'QXdetails' },
        {
          path: '/KyltCom',
          component: KyltCom,
          name: 'KyltCom',
          redirect: '/Promoin',
          children: [
            { path: '/Ltgk', component: Ltgk, name: 'Ltgk' },
            { path: '/Ltzlhgk', component: Ltzlhgk, name: 'Ltzlhgk' },
            { path: '/NewsList', component: NewsList, name: 'NewsList' },
            { path: '/DhxwDetails', component: DhxwDetails, name: 'DhxwDetails' }
          ]
        },
        { path: '/LtgkDetails', component: LtgkDetails, name: 'LtgkDetails' },
        { path: '/KyzhzxDetails', component: KyzhzxDetails, name: 'KyzhzxDetails' },
        { path: '/NewsKyzhzx', component: NewsKyzhzx, name: 'NewsKyzhzx' }
      ]
    },
    { path: '/PDFfile', component: PDFfile, name: 'PDFfile' }, //查看pdf文件
    { path: '/FictitiousZT', component: FictitiousZT, name: 'FictitiousZT' }, //虚拟展厅
    { path: '/Kyyztoply', component: Kyyztoply, name: 'Kyyztoply' },  //矿业一张图openlayers
    { path: '/KyyztModule', component: KyyztModule, name: 'KyyztModule' },  //矿业一张图修改模块
    { path: '/LargeScreen', component: LargeScreen, name: 'LargeScreen' },  //数字大屏
    { path: '/PanoramicView', component: PanoramicView, name: 'PanoramicView' },  //全景照片展示
    // 后台登录页
    {
      path: '/loginHT',
      component: loginHT,
      name: 'loginHT',
      meta: {title: '后台管理系统', requireAuth: true}
    },
    // 后台系统页
    {
      path: '/MenuRight',
      component: MenuRight,
      name: 'MenuRight',
      redirect: '/loginHT',
      meta: {title: '后台管理系统', requireAuth: true},
      children: ChildrenData.children,
      beforeEnter: (to, from, next) =>
      {
        const authValue = sessionStorage.getItem('auth')
        if (!authValue)
        {
          // 如果 authValue 为空，重定向到登录页面
          next('/loginHT')
        }
        else
        {
          // 如果 authValue 有值，允许访问
          next()
        }
      }
    },
    // 如果路径错误，会重定向到404页面
    // { path: '*', redirect: '/404' },
    { path: '/', redirect: '/Kyforum' }  //首页重定向
  ]
}
obj = pcobj
export default new Router(obj)

// 避免路由冗余
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to)
{
  return VueRouterPush.call(this, to).catch(err => err)
}




// WEBPACK FOOTER //
// ./src/router/index.js